module.exports = __webpack_public_path__ + "img/small-circle.50953204.png";